import { useQuery } from '@tanstack/react-query';
import { getClasificacionesGrupoTemporada } from '../../services/clasificacionService';

/**
 * Hook para obtener la clasificación de una temporada, competición y grupo
 * @param {number} idTemporada - ID de la temporada
 * @param {number} idCompeticion - ID de la competición
 * @param {number} idGrupo - ID del grupo
 * @param {object} options - Opciones adicionales de React Query
 */
export const useClasificacion = (idTemporada, idCompeticion, idGrupo, options = {}) => {
  return useQuery({
    queryKey: ['clasificacion', idTemporada, idCompeticion, idGrupo],
    queryFn: async () => {
      const navigate = null;
      return await getClasificacionesGrupoTemporada(
        idTemporada,
        idGrupo,
        navigate
      );
    },
    enabled: !!(idTemporada && idGrupo),
    ...options,
  });
};
